module.exports = __webpack_public_path__ + "static/media/hunt-image.2b22adc4.png";